import React, {useContext, useEffect} from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import Card from "./InquiryCard";
import { AppContext } from "../../RoundRegContext";

const InquiryCardGroup = ({ list }) => {
	const { dragListChange } = useContext(AppContext);

	return (
		<DndProvider backend={HTML5Backend}>
			<ul className="inquiry-card-group">
				{list.map((card, i) => {
					if (card.type !== "TITLE") {
						return (
							<Card
								key={i}
								idx={i}
								index={card.order}
								card={card}
								moveCard={dragListChange}
							/>
						);
					}
				})}
			</ul>
		</DndProvider>
	);
};

export default InquiryCardGroup;
